import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Pagination } from '../../models/pagination.interface';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { environment } from '../../../../environments/environment';
import { Location, LocationDTO } from '../../models/location.interface';
import { RequestService } from '../request/request';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { QueryGet } from '../../types/query-types';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'locations/';
  url = environment.service_1 + 'all-locations/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedlocation = new BehaviorSubject<Location | null>(null);
  selectedlocation$ = this.selectedlocation.asObservable();

  private locations = new BehaviorSubject<Location[]>([]);
  locations$ = this.locations.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setLocation(location: Location) {
    this.selectedlocation.next(location);
  }

  setLocations(locations: Location[]) {
    this.locations.next(locations);
  }

  removeLocationSelected() {
    this.selectedlocation.next(null);
  }

  createLocation(location: LocationDTO) {
    return this.http.post<Location>(this.urlPath, location).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateLocation(id: number, location: LocationDTO & { id: number }) {
    return this.http.put<Location>(this.urlPath + id + '/', location).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getLocation(query: QueryGet): Observable<Pagination<Location[]>> {
    return this.requestService.get<Location[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getLocations(): Observable<Location[]> {
    return this.http.get<Location[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionLocations(line: Location[]): OptionSelect[] {
    return line.map((item: Location) => {
      return {
        value: item.id ?? '',
        label: item.department + ' - ' + item.city,
      };
    });
  }
}
